import script from "./SelfAssess.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfAssess.vue?vue&type=script&setup=true&lang=js"

import "./SelfAssess.vue?vue&type=style&index=0&id=fd6e2094&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd6e2094"]])

export default __exports__